import * as angular from "angular";
import {IController, IOnChangesObject, IPromise, ITimeoutService} from "angular";
import {SplitService} from "../../../commons/services/split-service.service";
import {OmsRequestsService} from "../../services/oms-requests.service";
import {OmsOrderFilterModel} from "../../models/oms-order-filter.model";
import {OmsOrdersQuantitiesModel} from "../../models/oms-orders-quantities.model";
import {OmsOrdersFooterActionModel} from "../../models/oms-orders-footer-action.model";

// Ticking several rows in a row should send one request, not one per click.
const QUANTITIES_DEBOUNCE_MS = 500;

export class OmsOrdersActionFooterCtrl implements IController {
  filter: OmsOrderFilterModel;
  actions: OmsOrdersFooterActionModel[];
  extraActions: OmsOrdersFooterActionModel[];
  onActionSelect: Function;
  onClear: Function;

  public quantities: OmsOrdersQuantitiesModel;
  // The selection the request last settled for; the footer is loading until it catches up with `filter`.
  private settledFilter: OmsOrderFilterModel;
  public weightUnit: string;
  public volumeUnit: string;

  private fetchTimeoutRef: IPromise<void>;

  /* @ngInject */
  constructor(private omsRequestsService: OmsRequestsService, private splitService: SplitService,
              private $timeout: ITimeoutService, private $log) {
    this.weightUnit = this.splitService.getWeightUnit();
    this.volumeUnit = this.splitService.getVolumeUnit();
  }

  get isLoading(): boolean {
    return this.settledFilter !== this.filter;
  }

  $onChanges(changes: IOnChangesObject) {
    if (changes.filter) {
      this._fetchQuantities();
    }
  }

  $onDestroy() {
    this.$timeout.cancel(this.fetchTimeoutRef);
  }

  private _fetchQuantities() {
    this.$timeout.cancel(this.fetchTimeoutRef);
    if (!this.filter) {
      return;
    }

    const filter = this.filter;
    this.fetchTimeoutRef = this.$timeout(() => {
      this.omsRequestsService.getOrdersQuantities(filter)
        .then((quantities) => {
          // The selection may have changed while this request was in flight.
          if (filter === this.filter) {
            this.quantities = quantities;
          }
        })
        .catch((error) => {
          this.$log.error('Failed to get OMS orders quantities', error);
        })
        .finally(() => {
          if (filter === this.filter) {
            this.settledFilter = filter;
          }
        });
    }, QUANTITIES_DEBOUNCE_MS);
  }
}

angular
  .module('bringoz.admin.oms')
  .component('omsOrdersActionFooter', {
    bindings: {
      filter: '<',
      actions: '<',
      extraActions: '<',
      onActionSelect: '&',
      onClear: '&'
    },
    template: require('./oms-orders-action-footer.html').default,
    controller: OmsOrdersActionFooterCtrl
  });
